// src/components/Common/Spinner.js
import React from "react"; // Hapus useEffect karena tidak lagi digunakan
import { Spinner } from "reactstrap";

const Spinners = ({ color, style, className }) => { // Terima props yang relevan untuk visual spinner
    return (
        <React.Fragment>
            {/* Menggunakan props yang diterima, dengan fallback default jika tidak disediakan */}
            <Spinner
                color={color || "primary"} // Default warna jika tidak ada
                className={className || 'position-absolute top-50 start-50'} // Default class jika tidak ada
                style={style} // Menerima style tambahan dari parent
            />
        </React.Fragment>
    );
};

export default Spinners;